module.exports = __webpack_public_path__ + "static/media/logos-about.f94dbbe3.svg";